<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M12.25 7.24976L5.90625 13.5945C5.38743 14.1133 5.12792 14.3728 4.8252 14.5583C4.55689 14.7228 4.26398 14.8432 3.95801 14.9167C3.61275 14.9996 3.24549 14.9998 2.51172 14.9998H1.7998C1.52005 14.9998 1.38035 14.9995 1.27344 14.9451C1.17946 14.8972 1.10263 14.8212 1.05469 14.7273C1.00019 14.6203 1 14.48 1 14.2V13.488C1 12.7547 1.00021 12.3879 1.08301 12.0427C1.15649 11.7367 1.27794 11.4439 1.44238 11.1755C1.62791 10.8728 1.88739 10.6133 2.40625 10.0945L8.75 3.74976L12.25 7.24976ZM14.25 13.4998C14.6641 13.4998 14.9999 13.8357 15 14.2498C15 14.664 14.6642 14.9998 14.25 14.9998H8.75C8.33579 14.9998 8 14.664 8 14.2498C8.00013 13.8357 8.33587 13.4998 8.75 13.4998H14.25ZM10.75 1.74976C11.7165 0.783434 13.2835 0.783434 14.25 1.74976C15.2165 2.71621 15.2164 4.28325 14.25 5.24976L13.3105 6.18921L9.81055 2.68921L10.75 1.74976Z"
    fill="currentColor"
  />
</svg>
